import * as turf from '@turf/turf';
import type { GeometryType } from './types';

export const toBdPoint = (coordinates: [number, number]) => {
  return new window.BMapGL.Point(
    Number(coordinates[0]),
    Number(coordinates[1])
  );
};

export const readPointCoordinates = (point: any): [number, number] => {
  if (!point) {
    return [0, 0];
  }
  return [Number(point.lng), Number(point.lat)];
};

export const cloneCoordinates = (coordinates: any) =>
  JSON.parse(JSON.stringify(coordinates));

export const createGeometry = (geometryType: GeometryType, coordinates: any) => {
  return {
    getType: () => geometryType,
    getCoordinates: () => cloneCoordinates(coordinates),
    getFlatInteriorPoint: () => {
      if (geometryType !== 'Polygon') {
        return coordinates;
      }
      const polygon = turf.polygon([coordinates]);
      return turf.centroid(polygon).geometry.coordinates;
    },
    setCoordinates: (nextCoordinates: any) => {
      coordinates = cloneCoordinates(nextCoordinates);
    },
  };
};

export const extractOpacity = (color?: string) => {
  if (!color) {
    return 1;
  }
  const matched = color.match(/rgba\([^,]+,[^,]+,[^,]+,\s*([^)]+)\)/);
  return matched ? Number(matched[1]) : 1;
};
